import React, { useRef, useEffect } from "react";
import { Canvas, useFrame, useLoader } from "@react-three/fiber";
import {
  Bounds,
  CameraShake,
  Center,
  OrbitControls,
  useBounds,
  useGLTF,
} from "@react-three/drei";
import * as THREE from "three";
import dat from "dat.gui"; // Voeg dat.gui toe
import { Line, LineBasicMaterial, BufferGeometry, Vector3 } from "three";
import { GaasMaterial } from "./GaasMateriaal";
import { useForm, useFormContext, useWatch } from "react-hook-form";
import { formConfig } from "../form/formConfig";
import { useSpring, a } from '@react-spring/three';
import { berekenBreedte } from "./Helpers";
import { Renderer } from "three/webgpu";



const PlankRepeater = ({ spacing = 0.2, startX = 0 }) => {
  const { WIDTH, HEIGHT } = useWatch({ name: "DIMENSION" });

    // BREEDTE Mappen naar dichtsbijzijnde waarde:
  const {gecorrigeerdeBreedte, aantal_planken} = berekenBreedte(WIDTH);

  const default_frame_code = formConfig.find(
    (x) => x.name == "FRAME_COLOR"
  ).defaultValue;
  const frameColor = useWatch({ name: "FRAME_COLOR" }) || default_frame_code; // Voor de framekleur

  console.log(frameColor);


  const option_color = formConfig
  .find((x) => x.name == "FRAME_COLOR")
  .options.find((x) => x.code == frameColor);

 


  const b = 1.3;

  const originalTexture = useLoader(
    THREE.TextureLoader,
    option_color.file
  );

  const plankRepeaterTexture = originalTexture.clone();
  plankRepeaterTexture.wrapS = plankRepeaterTexture.wrapT = THREE.RepeatWrapping;
  plankRepeaterTexture.repeat.set(b,b); // Verhoog deze waarden voor een fijnere maas
  plankRepeaterTexture.rotation = Math.PI / 2; // 90 graden rotatie
  plankRepeaterTexture.offset.setX(1)
  
  const newWoodMaterial = new THREE.MeshStandardMaterial({
    map: plankRepeaterTexture, 
    name: "PLANK RECHTOP",
    roughness: 1,  // Hout heeft vaak een wat ruw oppervlak
    metalness: 0,  // Geen metalen glans
    toneMapped: false,
    depthTest: true, // Standaard true, kun je op false zetten als het niet moet deelnemen aan dieptevergelijking
    depthWrite: true, // Zorgt ervoor dat het dieptebuffer wordt bijgewerkt
    polygonOffset: true,
    polygonOffsetFactor: 1, // Verhoog deze waarde om objecten verder van elkaar te schuiven in de diepte
    polygonOffsetUnits: 1

  });

  const { scene } = useGLTF("/plank.glb");

  // Update materialen in het 3D-model
  scene.traverse((child) => {
    if (child.isMesh) {
          child.material = newWoodMaterial;
      }
    })




  // Maak een array met plank-klonen
  const planks = [];

  scene.traverse((child) => {
    if (child.isMesh && child.morphTargetInfluences) {
      // Mapping voor hoogte (500mm - 2500mm)
      const heightKeyshape = Math.max(
        0,
        Math.min(1, (HEIGHT - 50) / (250 - 50))
      );
      if (child.morphTargetInfluences[0] !== undefined)
        console.log(heightKeyshape);
        child.morphTargetInfluences[0] = heightKeyshape; // Schaalwaarde voor hoogte
    
    }
  });

  //const widthKeyshape = Math.max(0,Math.min(1, (gecorrigeerdeBreedte - 500) / (5000 - 500)));

  for (let i = 0; i < aantal_planken; i++) {
    const plankClone = scene.clone();
    plankClone.position.set(startX + i * spacing, 0, 0); // Positioneer elke plank
    planks.push(plankClone);
  }


  for (let i = 0; i < aantal_planken; i++) {
    const plankClone = scene.clone();
    plankClone.position.set(-startX - i * spacing, 0, 0); // Positioneer elke plank
    planks.push(plankClone);
  }



  return (
    <>
      {planks.map((plank, index) => (
        <primitive key={index} object={plank} />
      ))}
    </>
  );
};



const PlankModel = () => {
  const modelRef = useRef();
  const { scene } = useGLTF("/plank.glb"); // Zorg ervoor dat het pad correct is
  
  return <primitive ref={modelRef} object={scene} />;
}

const WindowModel = () => {
  const modelRef = useRef();
  const { scene } = useGLTF("/poort_v3.glb"); // Zorg ervoor dat het pad correct is
  
  const a = 5;
  const ay = 1.3;

  // Voorkom herhaaldelijke acties bij re-renders
  useEffect(() => {
    if (scene) {
      //scene.rotateY(0.20)
    }
  }, [scene]); // Alleen uitvoeren wanneer `scene` verandert

  const boxHelperRef = useRef(); // Ref voor de bounding box helper

  console.log("rerender WindowModel");
  // Dynamisch aanpassen van de bounds bij wijzigingen in dimensies
  const bounds = useBounds();

  const default_frame_code = formConfig.find(
    (x) => x.name == "FRAME_COLOR"
  ).defaultValue;
  

  const { WIDTH, HEIGHT } = useWatch({ name: "DIMENSION" });
  const {gecorrigeerdeBreedte, aantal_planken} = berekenBreedte(WIDTH);

  const frameColor = useWatch({ name: "FRAME_COLOR" }) || default_frame_code; // Voor de framekleur

  console.log(frameColor);


  const option_color = formConfig
  .find((x) => x.name == "FRAME_COLOR")
  .options.find((x) => x.code == frameColor);

 
  const mapTexture = useLoader(
    THREE.TextureLoader,
    option_color.file
  );


  useEffect(() => {
    if (!scene) return;



    // Pastel kleur (lichtblauw als voorbeeld)
    //const pastelColor = new THREE.Color(0xaec6cf);
   
    mapTexture.wrapS = mapTexture.wrapT = THREE.RepeatWrapping;
    mapTexture.rotation = Math.PI/2
    mapTexture.repeat.set(a,ay); // Verhoog deze waarden voor een fijnere maas

    const newWoodMaterial = new THREE.MeshStandardMaterial({
      map: mapTexture, 
      name: "TEST",
      toneMapped: false,
      polygonOffset: true,
  polygonOffsetFactor: 1, // Verhoog deze waarde om objecten verder van elkaar te schuiven in de diepte
  polygonOffsetUnits: 1
    });

    // Update materialen in het 3D-model
    scene.traverse((child) => {
      if (child.isMesh) {
       
            child.material = newWoodMaterial;
      }
    });
  }, [frameColor, mapTexture, WIDTH, HEIGHT]);

  /*
  useEffect(() => {
    if (!scene || !modelRef.current) return;

    // Voeg een bounding box helper toe
    const boundingBox = new THREE.Box3().setFromObject(scene); // Bepaal de bounding box van het object
    if (boxHelperRef.current) {
      modelRef.current.remove(boxHelperRef.current); // Verwijder de oude helper
    }

    const boxHelper = new THREE.Box3Helper(boundingBox, 0xff0000); // Rood voor visualisatie
    boxHelperRef.current = boxHelper;
    modelRef.current.add(boxHelper); // Voeg de helper toe aan het model

  }, [scene, WIDTH, HEIGHT]);*/

  useEffect(() => {
    if (!HEIGHT || !WIDTH) {
      //bounds.refresh();
      return;
    }

    mapTexture.wrapS = mapTexture.wrapT = THREE.RepeatWrapping;
    mapTexture.rotation = Math.PI/2
    mapTexture.repeat.set(a,ay); // Verhoog deze waarden voor een fijnere maas

    // Pas morphTargetInfluences aan op basis van 'dimensions'
    scene.traverse((child) => {
      if (child.isMesh && child.morphTargetInfluences) {
        // Stel morphTargets in op basis van de dimensies

        // Mapping voor hoogte (500 - 1500mm)
        const heightKeyshape = Math.max(
          0,
          Math.min(1, (HEIGHT - 50) / (250 - 50))
        );


        // Mapping voor breedte (500mm - 1500mm)
        // 30 + 20 + 20
        const widthKeyshape = Math.max(
          0,
          Math.min(1, (gecorrigeerdeBreedte - 1000) / (10000 - 1000))
        );

        if (child.morphTargetInfluences[0] !== undefined)
          child.morphTargetInfluences[0] = widthKeyshape; // Schaalwaarde voor hoogte
        if (child.morphTargetInfluences[1] !== undefined)
          child.morphTargetInfluences[1] = heightKeyshape; // Schaalwaarde voor breedte
      }
    });

    //bounds.refresh().clip().fit()
    //bounds.moveTo([0, 10, 10]).lookAt({ target: [5, 5, 0], up: [0, -1, 0] })
    //bounds.refresh(modelRef.current).fit()
  }, [WIDTH, HEIGHT]); // Trigger effect bij wijzigingen in dimensies

  return <primitive ref={modelRef} object={scene} />;
};

const Raam = () => {
  const modelRef = useRef();
  const { scene } = useGLTF("/window_2_a.glb"); // Zorg ervoor dat het pad correct is

  return <primitive ref={modelRef} object={scene} />;
};


const interpolateFunc = (t) => 1 - Math.exp(-5 * t) + 0.007 * t // Matches the default Bounds behavior
const interpolateFunc1 = (t) => -t * t * t + 2 * t * t          // Start smoothly, finish linearly
const interpolateFunc2 = (t) => -t * t * t + t * t + t          // Start linearly, finish smoothly


export const ConfiguratorContainer = () => {
  console.log("rerender 3D configurator");
  const [spring, api] = useSpring(() => ({
    color: 'white',
    config: { tension: 280, friction: 60 },
  }));

  
  return (
    <Canvas
    camera={{ near: 0.1, far: 25 }}
      style={{
        width: "100%",
        flex: 1,
        
      }}
      gl={{outputColorSpace: 'srgb-linear', toneMapping: 4 }}

    >
      
      {/* Basis licht */}
      <ambientLight intensity={1.5} />


      {/* Directional light met schaduw */}
      <directionalLight
        position={[0, 0, 10]}
        intensity={1.4}
       
      />

            {/* Directional light met schaduw */}
            <directionalLight
        position={[0, 0, -10]}
        intensity={1.4}
       
      />



<group rotation={[0, 0.2, 0]}>

      <OrbitControls
      
        minAzimuthAngle={-Math.PI /4*3} // Beperk rotatie Y-as tot -30°
        maxAzimuthAngle={Math.PI/4*3 } // Beperk rotatie Y-as tot +30°
        minPolarAngle={Math.PI / 4} // Beperk hoogte tot minimaal 45° boven de horizon
        maxPolarAngle={Math.PI / 2} // Beperk hoogte tot maximaal 90° (recht naar beneden kijken)
        enableZoom={false} // Zoom toestaan
        zoomSpeed={0.5} // Pas zoomsnelheid aan
        enablePan={false} // Pannen uitschakelen
    
        makeDefault
      />

      <Bounds
        //interpolateFunc={interpolateFunc2} // Probeer hier een elastic easing of een sinusvorm.
        fit
        clip
        observe
        margin={0.55}
        maxDuration={3}
        
        
>
        <Center>
          <WindowModel />
          <PlankRepeater count={11} startX={0.255} spacing={0.225} />
        </Center>
      </Bounds>
      </group>
    </Canvas>
  );
};
